import { AfterViewInit, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Guid } from 'guid-typescript';
import { FileServerModel } from 'src/app/models/file-server.model';
import { JobModel } from 'src/app/models/job.model';
import { ColorsModel } from 'src/app/models/colors.model';
import { ProductModel } from 'src/app/models/products';
import { TaskGruopModel } from 'src/app/models/task-group.model';
import { UploaderSettingModel } from 'src/app/models/uploaderSetting.model';
import { FileServerService } from 'src/app/services/file-server.service';
import { PoolColorsService } from 'src/app/services/pool-colors.service';
import { ProductService } from 'src/app/services/product.service';
import { ToastService } from 'src/app/services/toast.service';
import { WorkTaskService } from 'src/app/services/work-task.service';
import { UserService } from 'src/app/shared/services/user.service';
import { BaseColorsModel } from 'src/app/models/base-colors.model';
import { ActivatedRoute } from '@angular/router';
import { ProductCategoryModel } from 'src/app/models/product-category.model';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { lastValueFrom } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { NgStyle } from '@angular/common';
import { MatFormField } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { FileUploaderComponent } from '../../../shared/components/file-uploader/file-uploader.component';
import { FilterByProductNamePipe } from '../../../shared/pipes/filter-by-product-name.pipe';

import { MatButton, MatIconButton } from '@angular/material/button';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';

@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss'],
    imports: [MatIcon, FormsModule, NgStyle, ReactiveFormsModule, MatFormField, MatSelect, MatOption, FileUploaderComponent, FilterByProductNamePipe, MatButton, MatIconButton, PageHeaderComponent]
})
export class ProductListComponent implements OnInit, AfterViewInit {
  private readonly productSvc = inject(ProductService);
  usrSvc = inject(UserService);
  dialog = inject(MatDialog);
  toastr = inject(ToastService);
  activatedRoute = inject(ActivatedRoute);
  private readonly workTaskSvc = inject(WorkTaskService);
  fileServerSrv = inject(FileServerService);
  poolColorsSrv = inject(PoolColorsService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);

  displayedColumns: string[] = [
    'name',
    'description',
    'action' /*, 'subCategoryId'*/,
  ];

  products: ProductModel[] = [];
  taskGroups: TaskGruopModel[] = [];

  selectedGroup = new FormControl();
  currentSubcategories: JobModel[] = [];

  selectedSubcategories = new FormControl([]);
  selectedProductCategories: ProductCategoryModel[] = [];

  colors: ColorsModel[] = [];
  isPiscina: boolean = false;
  searchText!: string;
  uploadersetting!: UploaderSettingModel;
  disableEdit: boolean = false;
  durationUnits: string[] = [];
  durations: number[] = [];

  productForm = new UntypedFormGroup({
    id: new UntypedFormControl(Guid.EMPTY),
    name: new UntypedFormControl('', Validators.required),
    alias: new UntypedFormControl('', Validators.required),
    description: new UntypedFormControl('', Validators.required),
    productCategories: new UntypedFormControl([], Validators.required),
    productColors: new UntypedFormControl([]),
    productImg: new UntypedFormControl(null),
    file: new UntypedFormControl(null),
  });

  ngOnInit(): void {
    this.uploadersetting = {
      accept: ['image/png', 'image/jpg', 'image/jpeg'],
      inputWhith: '50%',
      imgWhith: '50%',
      imgHeight: '100%',
      imgMaxHeight: '270px',
      imgMaxWhith: '50%',
      controller: 'fileServerSrv.Products',
      formGroup: this.productForm,
    };
    this.getTaskGroups();
    this.getColors();
  }

  ngAfterViewInit(): void {
    this.getProducts();
  }

  getForm() {
    return new UntypedFormGroup({
      id: new UntypedFormControl(Guid.EMPTY),
      name: new UntypedFormControl('', Validators.required),
      alias: new UntypedFormControl('', Validators.required),
      description: new UntypedFormControl('', Validators.required),
      productCategories: new UntypedFormControl([], Validators.required),
      productColors: new UntypedFormControl([]),
      productImg: new UntypedFormControl(null),
    });
  }

  getProducts() {
    this.productSvc.get().subscribe((data: ProductModel[]) => {
      this.products = data;
    });
  }

  async editProduct(product: ProductModel) {
    if (!this.disableEdit) {
      this.disableClickForFiveSeconds();
      this.cleanForm();

      await this.getProductDetails(product.id);
      if (
        product.productCategories.some(
          (x) =>
            x.subCategoryId.toString() == '1af64f64-5717-4562-b3fc-2c963f66afa1'
        )
      ) {
        //id de 'Piscina'
        this.isPiscina = true;
        if (product.productColors) {
          this.setColorList();
          this.colors.forEach((p) => {
            let selected = product.productColors.find(
              (x) => x.colorId == p.colorId
            );
            if (selected) {
              p.id = selected.id;
            }
          });
        }
      }
    }
  }

  disableClickForFiveSeconds() {
    this.disableEdit = true;
    setTimeout(() => {
      this.disableEdit = false;
    }, 5000);
  }

  getTaskGroups() {
    this.workTaskSvc.getTaskGroups().subscribe((data: TaskGruopModel[]) => {
      this.taskGroups = [...this.taskGroups, ...data];
    });
  }

  getColors() {
    this.poolColorsSrv.getColors().subscribe((data: BaseColorsModel[]) => {
      data.forEach((color) => {
        this.colors.push({
          id: Guid.createEmpty().toString(),
          colorId: color.id,
          color: color.description,
        });
      });

      this.setColorList();
    });
  }

  /** The list row of the product open in the form (the form id is the selection; EMPTY = new product). */
  isSelectedProduct(product: ProductModel): boolean {
    const id = this.productForm.controls['id'].value?.toString();
    return !!id && id !== Guid.EMPTY && product.id?.toString() === id;
  }

  hasSelectedProduct(): boolean {
    const id = this.productForm.controls['id'].value?.toString();
    return !!id && id !== Guid.EMPTY;
  }

  cleanForm() {
    this.productForm.patchValue(this.getForm().value);
    this.productForm.markAsUntouched();
    this.selectedProductCategories = [];
    this.currentSubcategories = [];
    this.selectedGroup.reset();
    this.selectedSubcategories.reset();
    this.isPiscina = false;
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1.colorId === o2.colorId;
  }

  onSubmit() {
    const payload = this.prepareDurationForBackend();

    let result = this.selectedProductCategories.map(
      (x, index) =>
        <ProductCategoryModel>{
          subCategoryId: x.subCategoryId,
          categoryId: x.categoryId,
          price: x.price,
          defaultDuration: payload[index].defaultDuration,
        }
    );

    this.productForm.controls['productCategories'].setValue(result);

    if (this.productForm.invalid) {
      // The field errors render once touched; without this Guardar on an incomplete form did nothing visible.
      this.productForm.markAllAsTouched();
      this.toastr.error(
        'Datos incompletos',
        'Completá el nombre, el alias, la descripción y agregá al menos una tarea.'
      );
      return;
    }

    if (this.productForm.valid) {
      if (!this.isPiscina) {
        this.productForm.controls.productColors.patchValue(null);
      }

      let model = this.productForm.value as ProductModel;
      if (model.id == Guid.createEmpty()) {
        this.productSvc.post(this.productForm.value).subscribe(
          (result: any) => {
            this.toastr.success(
              'Nuevo producto',
              'Se ha guardado el nuevo producto exitosamente'
            );
            this.cleanForm();
            this.productForm.controls['id'].setValue(Guid.EMPTY);
            this.getProducts();
            this.isPiscina = false;
            this.setColorList();
          },
          () => {
            this.toastr.error('Error', 'No se pudo guardar el nuevo producto.');
          }
        );
      } else {
        this.productSvc.patch(this.productForm.value).subscribe({
          next: (result: any) => {
            if (
              this.productForm.controls.productImg.value &&
              !this.productForm.controls.productImg.value.id
            ) {
              let fileServerModel = this.productForm.controls.productImg
                .value as FileServerModel;
              this.fileServerSrv
                .UploadTaskFile(
                  model.id.toString(),
                  fileServerModel,
                  this.fileServerSrv.Products
                )
                .subscribe();
            }
            this.toastr.success(
              'Edición de producto',
              'Se ha actualizado el producto exitosamente'
            );
            this.getProducts();
            this.cleanForm();
            this.isPiscina = false;
            this.setColorList();
          },
          error: (err) => {
            this.toastr.error(
              'Error',
              'No se pudo actualizar el producto.' + err
            );
          },
        });
      }
    }
  }

  setColorList() {
    this.colors.forEach((color) => {
      color.id = Guid.EMPTY;
    });
  }

  getSubcategories(group: Guid) {
    this.isPiscina = false;
    this.workTaskSvc.getJobs(group).subscribe((data: JobModel[]) => {
      this.currentSubcategories = data.map(
        (x) =>
          <JobModel>{
            id: x.id,
            description: x.description,
            groupId: group,
          }
      );
      this.cdr.detectChanges();
    });
  }

  setIsPiscina() {
    this.isPiscina =
      [
        ...(this.selectedSubcategories.value ?? []),
        ...this.selectedProductCategories,
      ].some(
        (x: any) =>
          x.subCategoryDescription == 'Piscina' ||
          x.subCategoryDescription == 'Piscina y Equipamiento'
      ) ?? false;
  }

  async getProductDetails(productId: Guid) {
    try {
      this.cleanForm();

      const details = await lastValueFrom(
        this.productSvc.getProduct(productId)
      );

      // Obtener task groups utilizados en productCategories
      const usedGroups = new Set(
        details.productCategories.map((x) => x.categoryId)
      );

      // Crear un mapa para asociar descripciones de categorías
      const categoryMap = new Map<
        string,
        { description: string; jobs: JobModel[] }
      >();

      // Obtener información de las categorías en serie
      for (const group of this.taskGroups.filter((g) => usedGroups.has(g.id))) {
        const data = await lastValueFrom(this.workTaskSvc.getJobs(group.id));
        categoryMap.set(group.id.toString(), {
          description: group.description,
          jobs: data,
        });
      }

      // Procesar las categorías del producto
      this.selectedProductCategories = details.productCategories.map((pc) => {
        const categoryInfo = categoryMap.get(pc.categoryId.toString());

        return {
          ...pc,
          categoryDescription: categoryInfo?.description ?? 'Unknown',
          subCategoryDescription:
            categoryInfo?.jobs.find((x) => x.id === pc.subCategoryId)
              ?.description ?? 'Unknown',
        };
      });

      // Actualizar duración
      this.durations = details.productCategories.map(
        (pc) => pc.defaultDuration
      );
      this.durationUnits = new Array(details.productCategories.length).fill(
        'hours'
      );

      // Actualizar formulario
      this.productForm.patchValue(details);

      // Manejar imagen
      if (details.file) {
        const model: FileServerModel = {
          id: details.file.fileId.toString(),
          groupId: productId.toString(),
          name: 'productImg',
          imageSrc: details.file.url,
        };
        this.productForm.controls[model.name].patchValue(model);
      }

      this.setIsPiscina();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error fetching product details:', error);
    }
  }

  getProductId() {
    let id: string = '';
    this.activatedRoute.queryParams.subscribe((params) => {
      id = params['id'];
    });
    return id;
  }

  hideUploadFile() {
    return (
      !this.productForm.controls.id.value ||
      this.productForm.controls.id.value == Guid.EMPTY
    );
  }

  deleteProduct(product: ProductModel) {
    let prodId = product.id.toString();
    this.swalFire
      .SwalFireQuestion(
        'Eliminación',
        '¿Desea eliminar este producto?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.fileServerSrv
            .GetTaskFiles(prodId, this.fileServerSrv.Products)
            .subscribe((dataimg) => {
              dataimg.forEach((img) => {
                this.fileServerSrv.delete(img.id).subscribe();
              });
            });

          this.productSvc.deleteProduct(product.id).subscribe(
            (data) => {
              this.toastr.success(
                'Actualización',
                'El producto se eliminó correctamente.'
              );
              this.getProducts();
            },
            (err) => {
              this.toastr.error('Error', 'No se pudo eliminar el producto.');
            }
          );
        }
      });
  }

  addSelectedCategories() {
    this.selectedSubcategories.value!.forEach((element: any) => {
      if (!this.selectedProductCategories.some((x) => x.id == element.id))
        this.selectedProductCategories.push({
          subCategoryId: element.id,
          categoryId: element.groupId,
          price: 0,
          defaultDuration: 0,
          subCategoryDescription: element.description,
          categoryDescription: this.taskGroups.find(
            (x) => x.id == element.groupId
          )?.description,
          id: Guid.createEmpty(),
        });
    });

    this.selectedSubcategories.reset();
    this.selectedGroup.reset();
  }

  removeSelectedCategory(model: ProductCategoryModel) {
    this.selectedProductCategories = this.selectedProductCategories.filter(
      (x) => x.id != model.id
    );
    this.setIsPiscina();
  }

  onPriceInputChange(event: Event, index: number) {
    const inputElement = event.target as HTMLInputElement;

    if (!Number.isNaN(Number.parseFloat(inputElement.value))) {
      this.selectedProductCategories[index].price = Number.parseFloat(
        inputElement.value
      );
    } else {
      this.selectedProductCategories[index].price = 0;
    }
  }

  onDurationInputChange(event: Event, index: number) {
    const value = Number.parseFloat((event.target as HTMLInputElement).value);
    if (!Number.isNaN(value)) {
      this.durations[index] = value;
    }
  }

  prepareDurationForBackend() {
    const payload = this.selectedProductCategories.map((category, index) => {
      const durationInHours =
        this.durationUnits[index] === 'days'
          ? this.durations[index] * 24
          : this.durations[index];
      return {
        ...category,
        defaultDuration: durationInHours,
      };
    });

    return payload;
  }

  showInputPrice(product: ProductCategoryModel) {
    let JobModels = [
      '1af64f64-5717-4562-b3fc-2c963f66afa1',
      '1af64f64-5717-4562-b3fc-2c963f66afb1',
      '1af64f64-5717-4562-b3fc-2c963f66afc1',
      '1af64f64-5717-4562-b3fc-2c963f66aff1',
    ];

    if (
      product.categoryId.toString() == '1af64f64-5717-4562-b3fc-2c963f66afa1' &&
      JobModels.some((x) => x == product.subCategoryId.toString())
    ) {
      return true;
    }
    return false;
  }

  validateOnlyNumbers(event: KeyboardEvent, index: number) {
    let key = event.key;
    let inputElement = event.target as HTMLInputElement;

    if (
      !/\d/.test(key) &&
      key !== 'Backspace' &&
      key !== 'ArrowLeft' &&
      key !== 'ArrowRight' &&
      key !== 'Tab'
    ) {
      event.preventDefault();
    }

    setTimeout(() => {
      const durationValue = Number.parseFloat(inputElement.value) || 0;
      const maxAllowed = this.durationUnits[index] === 'days' ? 2 : 48;
      if (durationValue > maxAllowed) {
        inputElement.value = maxAllowed.toString();
        this.durations[index] = maxAllowed;
      } else {
        this.durations[index] = durationValue;
      }
    });
  }

  onKeyDownInObservations(event: KeyboardEvent, product: ProductModel): void {
    if (event.ctrlKey && event.key === 'Enter') {
      this.editProduct(product);
    }
  }
}
